import log from 'loglevel';
import React from 'react';
import 'url-search-params-polyfill';
import * as config from '../../app.config';
import CallbackConfirm from '../CallbackConfirm';
import CallbackValidate from '../CallbackValidate';
import ErrorBoundary from '../ErrorBoundary';
import UserInfoForm from '../UserInfoForm';
import './_Callback.scss';

class Callback extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      variables: {},
      step: 1,
    };
  }

  componentDidMount() {
    log.debug('Tealium script loading....');
    const script = document.createElement("script");
    script.src = config.tealiumUrl;
    script.async = false;
    document.body.appendChild(script);
  }

  componentWillMount() {
    const params = new URLSearchParams(window.location.search)
    const dataValue = params.get('data');
    const baseData = {
      buttonDisabled: true,
    };
    let userData = {};
    if (typeof dataValue !== 'undefined' && dataValue !== '' && dataValue !== null) {
      const userDetails = window.atob(dataValue);
      userData = {
        ...JSON.parse(userDetails),
      };
    }
    const data = { ...baseData, ...userData };
    this.setState({ variables: data });
  }

  setSubmitted = (variables) => {
    this.logAnalytics('request a call');
    this.setState({
      variables: variables,
      step: 2,
    },
    () => this.resizeModal(350));
  }

  setValidated = (variables) => {
    this.logAnalytics('verify your details');
    this.setState({
      variables: variables,
      step: 3,
    });
  }

  returnBack = (variables) => {
    this.setState({
      variables: variables,
      step: 1,
    },
    () => this.resizeModal(600));
  }

  closeModal = (verify = false) => {
    log.debug('closing modal');
    if (verify) {
      this.logAnalytics('verify your details');
    }

    // determine if component is mounted in an iframe (modal)
    let isIframe = true
    try {
      isIframe = window.self !== window.top;
    } catch (e) {
      isIframe = true
    }
    log.debug("component in iframe: ", isIframe)

    // send message to parent to close
    if (isIframe) {
      window.parent.postMessage('closeC2CModal', '*');
    }
    // close popup window
    else {
      window.close()
    }
  }

  resizeModal = (size) => {
    log.debug('resizeModal', size);
    window.parent.postMessage('resizeC2CModal:' + size, '*');
  }

  /**
   * Log analytics for each page
   *
   * "request a call"
   * "verify your details"
   * "you are all set"
   */
  logAnalytics = (content) => {
    window.__analyticsChangeContext = window.__analyticsChangeContext || [];
    window.__analyticsChangeContext.push({
      event: {
        eventType: "page_view"
      },
      page: {
        contentDescription: content,
        pageType: "c2c_modal_view"
      },
      transaction: {
        transactionPlatform: "",
        transactionType: "waf - c2c",
        transactionSubType: "standard"
      }
    });
  }

  render() {
    if (this.state.step === 1) {
      this.resizeModal(600)
    }
    return (
      <ErrorBoundary>
        <div className="App">
          {this.state.step === 1 ?
            <UserInfoForm
              setSubmitted={this.setSubmitted}
              closeModal={this.closeModal}
              variables={this.state.variables}
            /> : null
          }
          {this.state.step === 2 ?
            <CallbackValidate
              setValidated={this.setValidated}
              returnBack={this.returnBack}
              closeModal={this.closeModal}
              variables={this.state.variables}
            /> : null
          }
          {this.state.step === 3 ?
            <CallbackConfirm
              closeModal={this.closeModal}
              variables={this.state.variables}
            /> : null
          }

          {/* <Trans>ORDER SUPPORT</Trans>
            <Trans>Request a call</Trans>
            <Trans>Support available in English only.*</Trans>
            <Trans>Open hours:</Trans> */}
          {/* <Trans>Mon–Fri, {weekdayFrom} to {weekdayTo} {timezone} Sat, {satFrom} to {satTo} {timezone} (chat support only)</Trans> */}
          {/* <Trans>Our agents will be available during the next business day. Please refer to the business open hours below.</Trans> */}
          {/* <Trans>Estimated wait time: </Trans> */}
          {/* <Trans>Estimated wait time: about </Trans> */}
          {/* <Trans>First name</Trans>
            <Trans>Last name</Trans>
            <Trans>Email</Trans>
            <Trans>Phone number</Trans>
            <Trans>Tell us about your issue</Trans>
            <Trans>Enter your question, providing as much context as you can</Trans>
            <Trans>VERIFY DETAILS</Trans>
            <Trans>CANCEL</Trans>
            <Trans>Invalid email address</Trans>
            <Trans>Invalid phone number</Trans>
            <Trans>Verify your details</Trans> */}
          {/* <Trans>Hello, {firstName} {lastName}</Trans> */}
          {/* <Trans>We will call you at {phoneNumber}. To change your number, click Back.</Trans> */}
          {/* <Trans>To initiate a call, click Request call.</Trans>
            <Trans>REQUEST CALL</Trans>
            <Trans>CANCEL REQUEST</Trans>
            <Trans>BACK</Trans>
            <Trans>You are all set!</Trans>
            <Trans>Your details have been recorded. One of our agents will be in touch with you.</Trans>
            <Trans>Thank you.</Trans>
            <Trans>CLOSE</Trans>
            <Trans>Service is unavailable at the moment. Please try again later.</Trans>
            <Trans>No agents are available at the moment. Please try again later.</Trans> */}

        </div>
      </ErrorBoundary>
    );
  }
}

export default Callback;
